import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Spinner } from '@betterment/samba-react';

import { AccountRecommendationOptionDocument } from './graphql/query.accountRecommendationOption.generated';
import { ProfileSetupContent } from './ProfileSetupContent';
import { RecommendationContent } from './RecommendationContent';

export const Content: React.FC = () => {
  const { data } = useGraphQLQuery(AccountRecommendationOptionDocument, { fetchPolicy: 'network-only' });

  const initialRecommendationOption = data?.accountRecommendationOption;
  const financialProfile = data?.financialProfile;

  if (data && !financialProfile) {
    return <ProfileSetupContent />;
  }

  if (initialRecommendationOption) {
    return <RecommendationContent initialRecommendationOption={initialRecommendationOption} />;
  }

  return (
    <Box css={{ justifyItems: 'center', alignContent: 'center', padding: 'space.400', minHeight: '400px' }}>
      <Spinner size="lg" />
    </Box>
  );
};
